import React, { useEffect, useState } from 'react'
import { Icon, Popup } from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux'
import { setDarkMode } from '../../features/darkMode/darkModeSlice'
import useAxios from '../../lib/auth/useAxios'
import './ThemeToggle.css'

const ThemeToggle = () => {
  const dispatch = useDispatch()
  const axios = useAxios()
  const darkMode = useSelector((state) => state.dark_mode?.value)
  const user = useSelector((state) => state.user.user)
  const [saving, setSaving] = useState(false)

  // Apply theme to body element
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode')
    } else {
      document.body.classList.remove('dark-mode')
    }
  }, [darkMode])

  // Load user's theme preference on mount
  useEffect(() => {
    if (user?.theme_preference) {
      dispatch(setDarkMode({ dark_mode: user.theme_preference === 'dark' }))
    } else {
      // Default to light mode
      dispatch(setDarkMode({ dark_mode: false }))
    }
  }, [user, dispatch])

  const handleToggle = async () => {
    const newDarkMode = !darkMode
    dispatch(setDarkMode({ dark_mode: newDarkMode }))
    
    // Save to backend
    if (user?.id) {
      setSaving(true)
      try {
        await axios.patch(`/main/custom-users/${user.id}/`, {
          theme_preference: newDarkMode ? 'dark' : 'light'
        })
      } catch (error) {
        console.error('Failed to save theme preference:', error)
        // Revert on error
        dispatch(setDarkMode({ dark_mode: !newDarkMode }))
      } finally {
        setSaving(false)
      }
    }
  }

  return (
    <Popup
      content={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      trigger={
        <button 
          className={`theme-toggle ${saving ? 'saving' : ''}`}
          onClick={handleToggle}
          disabled={saving}
          aria-label="Toggle theme"
        >
          <Icon 
            name={darkMode ? 'sun' : 'moon'} 
            className="theme-toggle-icon"
          />
        </button>
      }
      position="bottom center"
      inverted
      size="mini"
    />
  )
}

export default ThemeToggle